import script from "./CustomListDocMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomListDocMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CustomListDocMenu.vue?vue&type=style&index=0&id=769cdf7d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769cdf7d"]])

export default __exports__